import i18n from "config/i18next";

i18n.addResources("es", "workzonesTable", {
  date: "Último cambio",
  time: "Hora de cambio",
  workzone: "Zona de trabajo",
  maxQuantity: "Cantidad máx.",
  selectRegion: "Seleccioná una región para ver los resultados",
});
